import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';

// ProtectedRoute 컴포넌트 (Spring의 인터셉터와 유사)
// 인증이 필요한 페이지를 보호하는 컴포넌트
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  // 로딩 중일 때는 아무것도 표시하지 않음
  if (loading) {
    return <div>Loading...</div>; // 또는 로딩 스피너
  }
  
  // 인증되지 않았으면 로그인 페이지로 리다이렉트
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 인증되었으면 원래 보려던 페이지 표시
  return children;
};

export default ProtectedRoute;

